import { render, staticRenderFns } from "./ProfileWidgetItem.vue?vue&type=template&id=4227c786&scoped=true&"
import script from "./ProfileWidgetItem.vue?vue&type=script&lang=js&"
export * from "./ProfileWidgetItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileWidgetItem.vue?vue&type=style&index=0&id=4227c786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4227c786",
  null
  
)

export default component.exports